import axios from 'axios'

export let baseURL

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  baseURL = 'http://localhost:3000/'
} else {
  baseURL = 'https://trust-x.ifxurl.io/'
}



export const HTTP = axios.create(
  {
    baseURL: baseURL
  });


